import { HOT_DISPLAY_BUTTON_RENDERER as HOT_DISPLAY_BUTTON_RENDERER_TYPE } from './types';

// eslint-disable-next-line import/prefer-default-export
export const HOT_DISPLAY_BUTTON_RENDERER: HOT_DISPLAY_BUTTON_RENDERER_TYPE = 'HOT_DISPLAY_BUTTON_RENDERER';
